var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "bo-node-content", attrs: { fluid: "" } },
        [
          _c("meta-content", { attrs: { metaContentNodes: _vm.bonode } }),
          _vm._v(" "),
          _vm.isRootSportsNavigation ||
          (!_vm.isRootSportsNavigation && !_vm.mobileBigAndBelow) ||
          (!_vm.isRootSportsNavigation &&
            _vm.mobileBigAndBelow &&
            !_vm.secondaryBanners &&
            _vm.brandTemplate !== "generic_2")
            ? _c("headlinesLight", {
                attrs: {
                  category: "BettingHeadlines",
                  tiles: _vm.headlineTiles
                }
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.xtremepushWebInitialized || _vm.xtremePushEnabledMobile) &&
          _vm.xtremepushOnSiteEnabled &&
          _vm.xtremepushInlineContent
            ? _c("xtremepush-inline-content", {
                attrs: {
                  sportType: _vm.currentBoNavigation
                    ? _vm.currentBoNavigation.idfwbonavigation
                    : false,
                  section: "under_coupon_tabs"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.brandLayout === "generic" &&
          _vm.brandTemplate !== "generic_2" &&
          _vm.secondaryBanners &&
          _vm.mobileBigAndBelow &&
          _vm.currentBoNavigationHeadlines &&
            _vm.currentBoNavigationHeadlines.length > 0
            ? _c(
                "div",
                {
                  staticClass: "secondary_banners",
                  class: { notOnHome: !_vm.isRootSportsNavigation }
                },
                [
                  _c("headlinesLight", {
                    attrs: { category: "SidebarBanners" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.availableFeatureTabs &&
          _vm.availableFeatureTabs.length > 0 &&
          _vm.displayFeatureOnSportsOrEventPage
            ? _c("feature-tabs-widget", {
                attrs: {
                  isHomePage: _vm.isRootSportsNavigation,
                  competitions: _vm.competitions,
                  sportType: _vm.sportId,
                  isSportsPage: !!_vm.currentBoNavigation,
                  availableFeatureTabs: _vm.availableFeatureTabs,
                  displayMode: "carousel"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("bo-navigation", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.bonode && _vm.bonode.idfwbonavigation,
                expression: "bonode && bonode.idfwbonavigation"
              }
            ],
            staticClass: "child-navigation",
            attrs: { "preselect-first-node": true, astabs: "true" }
          }),
          _vm._v(" "),
          !_vm.isInPlayBoNode
            ? _c("div", { staticClass: "prematch-content" }, [
                _c(
                  "div",
                  { staticClass: "tab-coupons" },
                  _vm._l(_vm.tabCouponNodes, function(tabCoupon) {
                    return _c(
                      "div",
                      { key: tabCoupon.idfwbonavigation },
                      [
                        _c("tab-coupon", {
                          attrs: { tabcouponnode: tabCoupon }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.marketgroups && _vm.marketgroups.length > 0
                  ? _c("div", { staticClass: "marketgroups" }, [
                      _vm.isOddsBoost
                        ? _c(
                            "div",
                            _vm._l(_vm.marketgroups, function(mg, index) {
                              return _c("odds-boost-market-group", {
                                key: mg.idfwmarketgroup,
                                attrs: {
                                  idfwmarketgroup: mg.idfwmarketgroup,
                                  "events-grouping":
                                    _vm.bonode.displaytemplatename,
                                  maxevents: _vm.bonode.maxitems || 0,
                                  "show-marketgroup-name": false,
                                  counter: index,
                                  hideliveevents: _vm.bonode.overlay,
                                  isOddsBoost: true
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.marketgroups, function(mg, index) {
                              return _c("market-group", {
                                key: mg.idfwmarketgroup,
                                attrs: {
                                  idfwmarketgroup: mg.idfwmarketgroup,
                                  "events-grouping":
                                    _vm.bonode.displaytemplatename,
                                  counter: index,
                                  maxevents: _vm.bonode.maxitems || 0
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isInPlayBoNode
            ? _c(
                "div",
                [
                  _c("live-coupon", {
                    attrs: {
                      ontab: true,
                      idfosporttypescsv: _vm.bonode.csvparameters || "ALL",
                      maxeventspersporttype: _vm.bonode.maxitems,
                      couponname: _vm.bonode.name
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a88ea68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a88ea68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/boNodeContent.vue
// module id = null
// module chunks = 